import { WebStorageStateStore } from "oidc-client-ts";

const readEnv = (name) => (process.env[name] || "").trim();

const normalizeUrl = (value) => {
  if (!value) {
    return "";
  }

  try {
    const parsed = new URL(value);
    if (!parsed.pathname) {
      parsed.pathname = "/";
    }
    return parsed.toString();
  } catch {
    return value;
  }
};

const authority = readEnv("REACT_APP_OIDC_AUTHORITY");
const clientId = readEnv("REACT_APP_OIDC_CLIENT_ID");
const redirectUri = normalizeUrl(readEnv("REACT_APP_OIDC_REDIRECT_URI"));
const postLogoutRedirectUri = normalizeUrl(
  readEnv("REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI")
);
const scope = readEnv("REACT_APP_OIDC_SCOPE") || "openid profile email";

export const oidcEnabled = Boolean(
  authority && clientId && redirectUri
);

export const oidcConfig = oidcEnabled
  ? {
      authority,
      client_id: clientId,
      redirect_uri: redirectUri,
      ...(postLogoutRedirectUri
        ? { post_logout_redirect_uri: postLogoutRedirectUri }
        : {}),
      response_type: "code",
      scope,
      automaticSilentRenew: true,
      loadUserInfo: true,
      userStore: new WebStorageStateStore({ store: window.sessionStorage }),
      onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
      },
    }
  : null;